import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import {FormGroup, FormControl, FormBuilder, Validators} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {CommandUtil} from '../../../global/commandutil';
import {BsModalService, ModalDirective} from 'ngx-bootstrap/modal';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {environment} from '../../../../environments/environment';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import {KeHoach} from '../../../models/kehoach/kehoach';
import {LoaiKeHoach} from '../../../models/danhmuc/loaikehoach';
import {KeHoachService} from '../../../service/kehoach/service-kehoach';
import {KeHoachFileService} from '../../../service/kehoach/service-kehoachfile';
import {LoaiKeHoachService} from '../../../service/danhmuc/service-loaikehoach';


import {NavItemService} from '../../../service/staff/service-navitem';
import {Sessioncommand} from '../../../global/sessioncommand';
import {LogAction} from '../../../models/log/logaction';
import {LogActionService} from '../../../service/log/service-logaction';
import {DatePipe} from '@angular/common';
import {IdentityItemService} from '../../../service/log/service-identityitem';
import {IdentityItem} from '../../../models/log/identityitem';

@Component({
  templateUrl: './log.component.html',
  encapsulation: ViewEncapsulation.None
})
export class LogEgovComponent implements OnInit, AfterViewInit {
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public dataList: LogAction[];
  public identityItemList: IdentityItem[] = [];
  public srKeyword: string = '';
  public srIdentityItem: string = '';
  public srAction: string = '';
  public fromDate: Date;
  public toDate: Date;
  constructor( public logActionService: LogActionService,
               public formBuilder: FormBuilder,
               public identityItemService: IdentityItemService,
               public toastr: ToastrService,
               public bsModalService: BsModalService,
               public commandUtil: CommandUtil,
               public datePipe: DatePipe
  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {
    this.identityItemService.findAll().subscribe(data => this.identityItemList = data);
    this.search();

  }
  search()
  {
    let fDate :string = this.datePipe.transform(this.fromDate, 'yyyy-MM-dd');
    let tDate :string = this.datePipe.transform(this.toDate, 'yyyy-MM-dd');
    this.logActionService.findAllByPaging(this.srKeyword, this.srAction, this.srIdentityItem, fDate, tDate, this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.logActionService.getCountByKeyword(this.srKeyword, this.srAction, this.srIdentityItem, fDate, tDate).subscribe(recordCount => this.totalItems = recordCount);
  }


  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

